const GenderFooter = () => {
  return (
    <>
      <h5>WHY SEX MATTERS</h5>
      <p>
        Since certain symptoms affect only people who are genetically male or female, we need to know the sex you were assigned at birth to
        help guide you.
      </p>
    </>
  );
};

export default GenderFooter;
